module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/store_images/2@2x_dcf774bcb29a148923ed2da1f93b6cb1.png";